const getters = {
  sessionId(state) {
    return state.sessionId;
  },
  token(state) {
    return state.token ? state.token : localStorage.getItem('token');
  },
  phone(state) {
    return state.phone ? state.phone : localStorage.getItem('phone');
  },
  marketplaceInfo(state) {
    return state.marketplaceInfo || JSON.parse(localStorage.getItem('marketplaceInfo'));
  },
  imageUrl(state) {
    const marketplaceInfo = state.marketplaceInfo || JSON.parse(localStorage.getItem('marketplaceInfo'));
    return marketplaceInfo?.marketplaceLogoUrl;
  },
  isWalmart(state) {
    const marketplaceInfo = state.marketplaceInfo || JSON.parse(localStorage.getItem('marketplaceInfo'));
    return marketplaceInfo?.name === 'Flipkart Wholesale';
  },
  isColgate(state) {
    const marketplaceInfo = state.marketplaceInfo || JSON.parse(localStorage.getItem('marketplaceInfo'));
    return marketplaceInfo?.name === 'Colgate';
  },
  isOkCredit(state) {
    const marketplaceInfo = state.marketplaceInfo || JSON.parse(localStorage.getItem('marketplaceInfo'));
    return marketplaceInfo?.name === 'Ok Credit';
  },
  flagsData(state) {
    return state.flagsData ? state.flagsData : JSON.parse(localStorage.getItem('flagsData'));
  },
  reKyc(state) {
    return state.reKyc || JSON.parse(localStorage.getItem('re-kyc'));
  },
  isSetReKyc(state) {
    return state.isSetReKyc || JSON.parse(localStorage.getItem('isSetReKyc'));
  },
  notificationList(state) {
    return state.notificationList;
  },
  flagsAllData(state) {
    return state.flagsAllData ? state.flagsAllData : JSON.parse(localStorage.getItem('flagsAllData'));
  },
  guarantorLoanId(state) {
    return state.guarantorLoanId || JSON.parse(localStorage.getItem('guarantorLoanId'));
  },
  guarantorData(state) {
    return state.guarantorData || JSON.parse(localStorage.getItem('guarantorData'));
  },
  isGuarantor(state) {
    return state.isGuarantor || JSON.parse(localStorage.getItem('isGuarantor'));
  }
};
export default getters;
